import './lib/polyfill';
import Vue from 'vue';
import router from './router';
import App from './views/app.vue';
// import '../node_modules/amfe-flexible/index';
import './lib/hack';
import './lib/flex';
import './styles/global.less';

window.$ = $;
new Vue({
    router,
    render:h=>h(App),
}).$mount('#app');

// window.addEventListener('load', function(e) {
//     window.applicationCache.addEventListener('updateready', function(e) {
//         if (window.applicationCache.status === window.applicationCache.UPDATEREADY) {
//             // Browser downloaded a new app cache.
//             // Swap it in and reload the page to get the new hotness.
//             window.applicationCache.swapCache();
//             window.location.reload();
//         } else {
//             // Manifest didn't changed. Nothing new to server.
//         }
//     }, false);
// }, false);
//
// window.onerror = function(errorMessage, scriptURI, lineNumber,columnNumber,errorObj) {
//     alert(JSON.stringify({errorMessage, scriptURI, lineNumber,columnNumber,errorObj}));
// }
// var e = console.error;
// console.error = function(a,b,c){
//     alert(JSON.stringify({a,b,c}))
//     return e.call(console,a,b,c);
// }


// WEBPACK FOOTER //
// src/main.js